import { render, staticRenderFns } from "./GifPreview.vue?vue&type=template&id=5025c52a&scoped=true&"
import script from "./GifPreview.vue?vue&type=script&lang=ts&setup=true&"
export * from "./GifPreview.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./GifPreview.vue?vue&type=style&index=0&id=5025c52a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5025c52a",
  null
  
)

export default component.exports